import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Home from "./pages/Home";
import LearnMore from "./pages/LearnMore";
import Locations from "./pages/Locations";
import ConnectUs from "./pages/ConnectUs";
import Catalogue from "./pages/Catalogue";
import CatalogueMen from "./pages/Catalogue/Men";
import CatalogueWomen from "./pages/Catalogue/Women";
import { InquiryModalProvider } from "./context/InquiryModalContext";
import InquiryModal from "./components/InquiryModal";

function App() {
  return (
    <InquiryModalProvider>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/connectus" element={<ConnectUs />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route path="/catalogue/men" element={<CatalogueMen />} />
          <Route path="/catalogue/women" element={<CatalogueWomen />} />
        </Routes>
      </BrowserRouter>
      <InquiryModal />
    </InquiryModalProvider>
  );
}

export default App;
